(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/frejaeid/assets/javascripts/checker.js') >= 0) return;  svs.modules.push('/components/app/frejaeid/assets/javascripts/checker.js');
(function(svs) {
  svs.app.frejaeid.Checker = function(options) {
    var defaultProgressText = svs.core.detect.formfactor.mobile() ?
      'Försöker starta Freja eID-appen' :
      'Starta Freja eID-appen på din mobil eller surfplatta. Klicka på QR-ikonen och läs av QR-koden ovan med kameran.';
    this.model = new Backbone.Model({
      error: false,
      status: 1,
      progressText: defaultProgressText
    });
    this.authRef = options.authRef;
    var logger = svs.core.log.getLogger('app:frejaeid');
    var maxPolling = 90; 
    var maxRestarts = 4; 
    var pollingCount = 0;
    var authRestarts = 0;
    var stopPolling = false;
    var pollingTimeoutId = -1;
    var errorHandler = function(xhr) {
      var errorCode =
          xhr &&
          xhr.responseJSON &&
          xhr.responseJSON.error &&
          xhr.responseJSON.error.code;
      if (errorCode && errorCode === 666 && this.errorRetries > 0) {
        this.errorRetries = this.errorRetries - 1;
        logger.info('Received network error when doing freja signing, retrying freja. Retries left: ' + this.errorRetries);
        setTimeout(checker.bind(this), 1000);
      } else {
        this.model.set({ error: xhr });
      }
    };
    var successFn = function(resp) {
      var progressText = defaultProgressText;
      pollingCount = pollingCount + 1;
      if (resp.postToken) {
        logger.debug('postToken: ' + resp.postToken);
        this.model.set('postToken', resp.postToken);
      } else if (resp.status) {
        logger.debug('status: ' + resp.status);
        switch (resp.status) {
          case 0:
          case 1:
            progressText = defaultProgressText;
            break;
          case 2:
            progressText = 'Godkänn i din Freja eID-app.';
            break;
          case 3:
            this.stopPolling(this.showStatusMessage('Verifiering avbruten', 'Du har avbrutit verifieringen i Freja eID-appen.'), false);
            break;
          case 4:
            this.stopPolling(this.showStatusMessage('Verifiering avbruten', 'Verifieringen med Freja eID avbruten, var vänlig försök igen.'), false);
            break;
          case 5:
            this.stopPolling(this.showStatusMessage('Verifiering avbruten', 'Det tog för lång tid att godkänna din inloggning med Freja eID, var vänlig försök igen.'), false);
            break;
          case 6:
            break;
          default:
            logger.warn('Unhandle progress status: ' + resp.status);
        }
        this.model.set({
          status: resp.progessStatus,
          progressText: progressText
        });

        if (!stopPolling) {
          pollingTimeoutId = setTimeout(checker.bind(this), 1000);
        }

        if (pollingCount > maxPolling && authRestarts < maxRestarts) {
          pollingCount = 0;
          authRestarts = authRestarts + 1;
          this.stopPolling(svs.app.frejaeid.initAuth(function(response) {
            var authRef;
            if (response) {
              authRef = response && response.authRef || undefined;
            }
            svs.app.frejaeid.qrCodeGenerate(authRef);
            stopPolling = false;
            checker.call(this, response);
          }.bind(this)));
        }
      }
    };
    var checker = function(response) {
      if (response) {
        this.authRef = response && response.authRef;
      }
      svs.core.jupiter.call(
        {
          path: '/player/1/frejaeid/initauthsign/verify',
          method: 'POST',
          data: {
            authRef: this.authRef
          },
          context: this
        },
        successFn,
        errorHandler
      );
    };
    this.startPolling = function() {
      this.errorRetries = 3;
      checker.call(this);
    };
    this.stopPolling = function(callback, cancelAuth) {
      cancelAuth = cancelAuth === undefined ? true : cancelAuth;
      if (pollingTimeoutId) {
        clearTimeout(pollingTimeoutId);
      }
      stopPolling = true;
      if (cancelAuth) {
        this.cancelPoll(callback);
      }
    };
    this.cancelPoll = function(callback) {
      var options = {
        method: 'POST',
        path: '/player/1/frejaeid/cancelauth',
        context: this,
        data: {
          authRef: this.authRef
        }
      };
      svs.core.jupiter.call(
        options,
        function(response) {
          logger.info('Cancel poll: ' + response);
          Boolean(callback) && callback();
        },
        function(xhr) {
          var errorCode = xhr && xhr.responseJSON && xhr.responseJSON.error && xhr.responseJSON.error.code;
          logger.info(errorCode);
          Boolean(callback) && callback();
        }
      );
    };
    this.showStatusMessage = function(title, message) {
      svs.components.Modal.hide();
      var dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.CONFIRM,
        icon: 'exclamation-sign',
        title: title,
        message: [
          {
            type: svs.ui.dialog.message.TEXT,
            text: message
          }
        ],
        actions: [
          {
            title: 'Okej'
          }
        ]
      });
      svs.ui.dialog.api.add(dialog);
    };
  };
})(svs);


 })(window);